export function splitHttpUri(url: string): { params: string; uri: string } {
  const split = url?.includes('?') ? url.split('?') : [url, null];
  return {
    uri: split[0],
    params: split[1],
  };
}
